import { HttpErrorResponse } from "@angular/common/http";
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  DataStateChangeEventArgs,
  GridComponent,  
  SelectionSettingsModel,  
} from "@syncfusion/ej2-angular-grids";
import { IMyDpOptions } from "mydatepicker";
import { ToastrService } from "ngx-toastr";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { DateService } from "src/app/date.service";
import { GlobalComponent } from "src/app/global/global.component";
import { TimesheetVerificatioService } from "../../timesheet-verification/timesheet-verification.service";
import { claimListBO, EventEmitterBo, functionpermission, SaveBatchFileBO } from "../claims.model";
import { ClaimsService } from "../claims.service";
import { ClaimslistService } from "../claimslist.service";
import { ClaimListService } from "./claim-list.service";

@Component({
  selector: "app-claim-list",
  templateUrl: "./claim-list.component.html",
  styleUrls: ["./claim-list.component.scss"],
})
export class ClaimListComponent implements OnInit {
  is87IClaim: boolean = false;
  public onDestroy$: Subject<void> = new Subject<void>();
  @Output() claimListEmit = new EventEmitter<EventEmitterBo>();
  @Input() claimLsitEmitBo: EventEmitterBo = new EventEmitterBo();
  claimGridlistBo: claimListBO = new claimListBO();
  saveBatchFileBO: SaveBatchFileBO = new SaveBatchFileBO();
  @ViewChild("Claimpdflist") claimpdflist;  
  fp: functionpermission = new functionpermission();
  AllpayerList:any=[];
  AllCompanyList:any=[];
  ClearingHouseList:any=[];
  fromDate:any;
  toDate: any;
  activeTab: any;
  AllserviceList: any;
  clearingHouse_Id: string;  
  paymentstatus: any;

  selectedCustomData: any = [];
  SelectedClaimCheckBox: any = [];  
  serviceList: any = [];

  claimrowspot: number;
  CreatedBatchList: any;
  claimstatus: any;

  @ViewChild("cliamsGrid") public cliamsGrid: GridComponent;
  public ClaimsListGrid: Observable<DataStateChangeEventArgs>;
  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  public filterSettings: object;
  public formatOptions: object;
  public initialPage: object;
  AllClientList: any;
  AllEmployeeList: any;
  PayerList: any;
  value1: any;
  value2: any;
  value3: any;
  ResubmissionList: any;
  isViewbatches = false;
  today = new Date().toLocaleDateString();
  filterEndDate: any
  filterStartDate: any
  checkparams: any;  
  getclaimid: any;  
  documentType: string = "";
  claimstype: any;
  is87IClaimBoolean: boolean = false;
  IsButtonDisable: boolean = false;
  svcdateFilterTypeStr: string = 'true';

  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    disableSince: {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate() + 1,
    },
    showClearDateBtn: true,
    editableDateField: true,
  };
  private DecimalColumns: string[] = ["TOTALAMOUNT", "BALANCEDUEAMOUNT", "PAIDAMOUNT"];
  
  constructor(
    public global: GlobalComponent,
    public dateservice: DateService,
    public claimslistService: ClaimslistService,
    public TimesheetVservice: TimesheetVerificatioService,
    public toastservice: ToastrService,
    public claimsService: ClaimsService,
    private cdr: ChangeDetectorRef,
    public claimListService: ClaimListService) {
    this.ClaimsListGrid = this.claimslistService;
  }
 
  ngOnInit(): void {
    this.getpermission()
    if (this.global.isCheckOperationDashboardRecord == true) {
      if (this.global.globalclaimfilter != null) {
        this.claimGridlistBo.claimpaymentstatus = this.global.globalclaimfilter;
        if (this.global.globalClaimType) {
          this.is87IClaim = this.global.globalClaimType
        }
        if (this.global.globalCLaimStatus == 'active') {
          this.claimGridlistBo.claimCategory = 'active';
          this.activeTab = 'active'
        }
        else if (this.global.globalCLaimStatus == 'archive') {
          this.claimGridlistBo.claimCategory = 'archive'
          this.activeTab = 'archive'
        }
        else {
          this.activeTab = 'readyToBill'
        }
      }
    }
    else {
      this.activeTab = 'readyToBill'
    }
    // .........................................................................
    if (this.global.globalAgencyId == null ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == "" ||
      this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") {
      return;
    }
    this.filterSettings = {
      type: "Menu",
    };

    this.formatOptions = { type: "date", format: "MM/dd/yyyy" };

    if (this.claimLsitEmitBo.claimId != null) {
      this.activeTab = this.claimLsitEmitBo.activeTab
      this.claimGridlistBo.currentpageno = this.claimLsitEmitBo.currentpageno;
      this.claimGridlistBo.pageitem = this.claimLsitEmitBo.pageitem;
      this.claimGridlistBo.employeeId = this.claimLsitEmitBo.employeeId
      this.claimGridlistBo.clientId = this.claimLsitEmitBo.clientId;
      this.claimGridlistBo.companyId = this.claimLsitEmitBo.companyId;
      this.claimGridlistBo.payerId = this.claimLsitEmitBo.payerId;
      this.claimGridlistBo.resubmissionTypeLid = this.claimLsitEmitBo.resubmissionTypeLid;
      this.claimGridlistBo.claimType = this.claimLsitEmitBo.claimType
      this.claimGridlistBo.claimpaymentstatus = this.claimLsitEmitBo.claimpaymentstatus
      this.filterStartDate = this.claimLsitEmitBo.filterStartDate
      this.filterEndDate = this.claimLsitEmitBo.filterEndDate
      this.claimGridlistBo.serviceId = this.claimLsitEmitBo.serviceId
      this.initialPage = {
        currentPage: this.claimLsitEmitBo.currentpageno,
        pageCount: this.claimLsitEmitBo.pageitem,
        totalRecordsCount: 0,
        pageSize: this.pageSizes[5],
        pageSizes: this.pageSizes,
      }

    }
    else {
      this.initialPage = {
        currentPage: 1,
        totalRecordsCount: 0,
        pageCount: 10,
        pageSize: this.pageSizes[5],
        pageSizes: this.pageSizes,
      };
    }
    this.GetCliamtypeLov();
    this.getClaimGridList();
    this.GetCliamtypeLov();
    this.GetPaymentStatusListLov();
    this.GetCliamStatusListLov();
    this.getEmployeesDropdown();
    this.getClientDropDown();
    this.getGroupPayerList();
    this.getPayerList();
    this.getServiceList();
    this.getCompanyList();
    this.getClearingHouseList();
    this.getResubmissionList();

    this.selectionOptions = {
      checkboxOnly: true,
    };

    this.getpermission();
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '')) {
      let params = new URLSearchParams();
      params.append("pagecode", "CLAIMS");
      params.append("roleId", this.global.roleId);
      params.append("agencyId", this.global.globalAgencyId)
      this.claimsService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        if (data != null) {
          this.fp = data;
        }
        else {
          this.fp = new functionpermission();
        }
      },
        (err: HttpErrorResponse) => {
          this.fp = new functionpermission();
        })
    }
  }
  //----showTimesheetColumns-----//
  showClaimsGridColumns() {
    this.cliamsGrid.openColumnChooser(200, 50);
  }

  getActiveTab(TabChange) {
    this.activeTab = TabChange;
    this.getClaimGridList();
  }

  DateFormat(event, type, name) {
    if (type == "inputchanged") {
      if (name == "FromDate") {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let element = this.dateservice.inputFeildchangeReturnall(event);
          this.fromDate = element;
        }
      }
      if (name == "ToDate") {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let element = this.dateservice.inputFeildchangeReturnall(event);
          this.toDate = element;
        }
      }
    }
    if (type == "datechanged") {
      if (name == "FromDate") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let element = this.dateservice.Datechange(event);
          this.fromDate = element;
        }
      }
      if (name == "ToDate") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let element = this.dateservice.Datechange(event);
          this.toDate = element;
        }
      }
    }
  }
 
  GetCliamStatusListLov() {
    let params = new URLSearchParams();
    params.append("listCode", "CLAIMSTATUS");
    this.claimsService
      .getLovType(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.claimstatus = data;
          this.getClaimGridList();
        },
        (err: any) => {
          if (err) {
            this.toastservice.error(err, "Error"), 8000;
          }
        }
      );
  }
  //..group payer id
  getGroupPayerList() {
    let params = new URLSearchParams();
    params.append("listCode", "PAYER");
    this.claimsService
      .getLovType(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.PayerList = data;
        },
        (err: any) => {
          if (err) {
            this.toastservice.error(err, "Error"), 8000;
          }
        }
      );
  }
  getResubmissionList() {
    let params = new URLSearchParams();
    params.append("listCode", "RESUBMISSIONTYPE");
    this.claimsService
      .getLovType(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.ResubmissionList = data;
        },
        (err: any) => {
          if (err) {
            this.toastservice.error(err, "Error"), 8000;
          }
        }
      );
  }

  getServiceList() {
    this.claimsService.getServicedropDown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.serviceList = data;
    })
  }
  
  getClearingHouseList() {
    this.claimsService
      .getClearingHouseList()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.ClearingHouseList = JSON.parse(data);
        },
        (err: any) => {
          if (err) {
            this.toastservice.error(err, "Error"), 8000;
          }
        }
      );
  }
  getPayerList() {
    this.claimsService
      .getPayerList()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.AllpayerList = JSON.parse(data);
        },
        (err: any) => {
          if (err) {
            this.toastservice.error(err, "Error"), 8000;
          }
        }
      );
  }
  
  getCompanyList() {
    this.claimsService
      .getCompanyList()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.AllCompanyList = JSON.parse(data)
        },
        (err: any) => {
          if (err) {
            this.toastservice.error(err, "Error"), 8000;
          }
        }
      );
  }
  //.........GetAllClientDropDown.........
  getClientDropDown() {
    this.TimesheetVservice.GetAllClientDropDown()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.AllClientList = data
        },
        (err: any) => {
          if (err) {
            this.toastservice.error(err, "Error"), 8000;
          }
        }
      );
  }

  //........GetAllEmployeesDropdown.........
  getEmployeesDropdown() {
    this.TimesheetVservice.GetAllEmployeesDropdown()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.AllEmployeeList = data;
        },
        (err: any) => {
          if (err) {
            this.toastservice.error(err, "Error"), 8000;
          }
        }
      );
  }


  getClaimGridList() {
    if (this.activeTab == "readyToBill") {
      this.claimGridlistBo.claimStatusLid = this.claimstatus?.filter(
        (s) => s.lovName == "ReadyToBill"
      )[0].id;
    }
    if (this.activeTab == "active") {
      this.claimGridlistBo.claimStatusLid = this.claimstatus?.filter(
        (s) => s.lovName == "Exported"
      )[0].id;
    }
    if (this.activeTab == "archive") {
      this.claimGridlistBo.claimStatusLid = this.claimstatus?.filter(
        (s) => s.lovName == "Imported"
      )[0].id;
    }
    if (this.activeTab == "resubmit") {
      this.claimGridlistBo.claimStatusLid = this.claimstatus?.filter(
        (s) => s.lovName == "To Be Re-Submitted"
      )[0].id;
    }
    this.claimGridlistBo.svcdateFilterType = this.svcdateFilterTypeStr === 'true';
    this.claimGridlistBo.fromDate = (this.filterStartDate != null && this.filterStartDate != undefined && this.filterStartDate != '') ? this.global.getDateTimeString(this.filterStartDate) : null;
    this.claimGridlistBo.toDate = (this.filterEndDate != null && this.filterEndDate != undefined && this.filterEndDate != '') ? this.global.getDateTimeString(this.filterEndDate) : null;
    // this.claimGridlistBo.isCSG =  this.claimGridlistBo.csg == "true" ? true : false
    if(this.DecimalColumns.includes(this.claimGridlistBo.field.toUpperCase())){
      // this.claimGridlistBo.value = this.claimGridlistBo.value + '';
      this.claimGridlistBo.type = "decimal";
    }
    this.claimslistService.execute(this.claimGridlistBo);
    this.ClaimsListGrid.pipe(takeUntil(this.onDestroy$)).subscribe(
      (data: any) => {
        this.selectedCustomData = data.result;
        this.SelectedClaimCheckBox = []
        if (this.selectedCustomData.length > 0) {
          data?.result?.forEach(claimsid => {
            if (claimsid.id == this.claimLsitEmitBo.claimId) {
              let index = this.selectedCustomData.findIndex(e => e.id == this.claimLsitEmitBo.claimId)
              this.SelectedClaimCheckBox.push(claimsid.id)
              this.cliamsGrid.selectedRowIndex = parseInt(index.toString());
            }
          });
        }
      },
      (err: any) => {
        if (err) {
          this.toastservice.error(err, "Error"), 8000;
        }
      }
    );
  }

  saveBatchFile837() {
    this.IsButtonDisable = true;
    this.saveBatchFileBO.claimId = this.SelectedClaimCheckBox;
    this.claimListService
      .GenerateClaim837(this.saveBatchFileBO)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data) => {
          this.IsButtonDisable = false;
          this.CreatedBatchList = JSON.parse(data);
          this.toastservice.success("Batch File generated successfully!");
          this.downloadFile(this.CreatedBatchList);
          this.getClaimGridList();
          this.SelectedClaimCheckBox = [];
          this.saveBatchFileBO.clearingHouseId = null;
          setTimeout(() => {
            this.toastservice.clear();
          }, 8000);
        },
        (err: any) => {
          this.IsButtonDisable = false;
          if (err) {
            this.toastservice.error(err, "Error"), 8000;
          }
        }
      );
  }

  ClaimEmitpage(data) {
    this.claimLsitEmitBo.isCreate = true;
    this.claimLsitEmitBo.claimId = data?.id;
    this.claimLsitEmitBo.activeTab = this.activeTab
    this.claimLsitEmitBo.currentpageno =
      this.cliamsGrid.pagerModule.pagerObj.currentPage;
    this.claimLsitEmitBo.pageitem =
      this.cliamsGrid.pagerModule.pagerObj.pageSize;
    this.claimLsitEmitBo.employeeId = this.claimGridlistBo.employeeId;
    this.claimLsitEmitBo.clientId = this.claimGridlistBo.clientId;
    this.claimLsitEmitBo.companyId = this.claimGridlistBo.companyId;
    this.claimLsitEmitBo.payerId = this.claimGridlistBo.payerId;
    this.claimLsitEmitBo.resubmissionTypeLid = this.claimGridlistBo.resubmissionTypeLid;
    this.claimLsitEmitBo.claimType = this.claimGridlistBo.claimType
    this.claimLsitEmitBo.claimpaymentstatus = this.claimGridlistBo.claimpaymentstatus
    this.claimLsitEmitBo.filterStartDate = this.filterStartDate
    this.claimLsitEmitBo.filterEndDate = this.filterEndDate
    this.claimLsitEmitBo.serviceId = this.claimGridlistBo.serviceId
    this.claimLsitEmitBo.interchangeControlNumber = this.claimGridlistBo.interchangeControlNumber
    this.claimLsitEmitBo.patientControlNumber = this.claimGridlistBo.patientControlNumber
    this.claimLsitEmitBo.payerClaimReferenceNumber = this.claimGridlistBo.payerClaimReferenceNumber
    this.claimLsitEmitBo.claimGridType = data?.claimType;
    this.claimLsitEmitBo.claimNote = this.claimGridlistBo.claimNote;
    this.claimListEmit.emit(this.claimLsitEmitBo);
  }
  getClaimId(claimID) {
    this.getclaimid = claimID
  }

  deleteClaim() {
    this.IsButtonDisable = true;
    let deleteid = [];
    deleteid.push(this.getclaimid);
    this.claimListService
      .Deleteclaims(deleteid)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        this.IsButtonDisable = false;
        this.toastservice.success("Claim File Deleted successfully!");
        document.getElementById("deleteClaimModal").click();
        this.getClaimGridList();
        setTimeout(() => {
          this.toastservice.clear();
        }, 8000);
      },
        (err: any) => {
          this.IsButtonDisable = false;
          if (err) {
            this.toastservice.error(err, "Error"), 8000;
          }
        });
  }

  multipledeleteClaim() {
    this.IsButtonDisable = true;
    this.claimListService
      .Deleteclaims(this.SelectedClaimCheckBox)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        this.IsButtonDisable = false;
        this.toastservice.success("Claim File Deleted successfully!");
        this.SelectedClaimCheckBox = []
        document.getElementById("Multidelete").click();
        this.getClaimGridList();
        setTimeout(() => {
          this.toastservice.clear();
        }, 8000);
      },
        (err: any) => {
          this.IsButtonDisable = false;
          if (err) {
            this.toastservice.error(err, "Error"), 8000;
          }
        });
  }

  cancelDelete() {
    this.getclaimid = null
  }

  cancelmultidelete() {
    document.getElementById("deleteMultiTimesheet").click();
  }

  filterClaim() {
    if ((this.filterStartDate != null && this.filterStartDate != undefined && this.filterStartDate != '')
      && (this.filterEndDate != null && this.filterEndDate != undefined && this.filterEndDate != '')) {
      if (new Date(this.filterStartDate).getTime() > new Date(this.filterEndDate).getTime()) {
        this.toastservice.error("End date should greater than start date");
        return;
      }
    }
    this.getClaimGridList();
  }

  RefreshClaim() {
    this.claimGridlistBo.employeeId = null;
    this.claimGridlistBo.clientId = null;
    this.claimGridlistBo.companyId = null;
    this.claimGridlistBo.payerId = null;
    this.claimGridlistBo.resubmissionTypeLid = null;
    this.claimGridlistBo.claimType = ''
    this.claimGridlistBo.claimpaymentstatus = ''
    this.filterStartDate = null
    this.filterEndDate = null
    this.claimGridlistBo.serviceId = null
    this.claimGridlistBo.interchangeControlNumber = ''
    this.claimGridlistBo.patientControlNumber = ''
    this.claimGridlistBo.payerClaimReferenceNumber = ''
    // this.claimGridlistBo.csg = "false";
    // this.claimGridlistBo.isCSG = false;
    this.svcdateFilterTypeStr = 'true';
    this.claimGridlistBo.svcdateFilterType = true;
    this.getClaimGridList();
  }

  downloadFile(batchfile) {
    var FileSaver = require("file-saver");
    let blob = new Blob([batchfile.ediString], {
      type: "text/plain;charset=utf-8",
    });
    FileSaver.saveAs(blob, batchfile.fileName);
  }

  checkBoxClick(args) {
    this.SelectedClaimCheckBox = [];
    if (args.checked && args.target.classList.contains("e-checkselectall")) {
      var rowData: any = this.cliamsGrid.getSelectedRecords();
      this.selectedCustomData.forEach((element) => {
        this.SelectedClaimCheckBox.push(element.id);
      });
    } else if (args.target.classList.contains("e-checkselect")) {
      var rowfirst: any = this.cliamsGrid.getSelectedRecords();
      this.SelectedClaimCheckBox = rowfirst.map((claimId) => claimId.id);
    }

  }

  public dataStateChange(state): void {
    this.documentType = state.action.requestType.toString();

    if (this.documentType != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.claimGridlistBo.orderColumn = state.sorted[0].name;
        this.claimGridlistBo.orderType =
          state.sorted[0].direction === "descending" ? "DESC" : "ASC";
      }
    }
    if (
      this.documentType == "filtering" &&
      state.action.action != "clearFilter"
    ) {
      this.claimGridlistBo.field = state.action.currentFilterObject.field;
      this.claimGridlistBo.matchCase =
        state.action.currentFilterObject.matchCase;
      this.claimGridlistBo.operator = state.action.currentFilterObject.operator;
      this.claimGridlistBo.value = state.action.currentFilterObject.value;
      if (state.action.currentFilterObject.type == "number") {
        this.claimGridlistBo.value = (this.claimGridlistBo.value != null || this.claimGridlistBo.value == undefined)? this.claimGridlistBo.value.toString(): null;
      }
    }
    if ((this.documentType == "filtering" && state.action.action == "clearFilter") 
      || (state.action.action == "filter" && (this.claimGridlistBo.value == ""
      || this.claimGridlistBo.value == undefined || this.claimGridlistBo.value == null))) {
      this.claimGridlistBo.field = "clientName";
      this.claimGridlistBo.orderColumn = "clientName";
        this.claimGridlistBo.matchCase = false;
        this.claimGridlistBo.operator = "startswith";
        this.claimGridlistBo.value = "";
        this.claimGridlistBo.type = "string";
    }
    if (this.documentType != "refresh") {
      this.getClaimGridList();
    }
  }
  public onActionComplete(G) {
    this.claimGridlistBo.currentpageno =
      this.cliamsGrid.pagerModule.pagerObj.currentPage;
    this.claimGridlistBo.pageitem =
      this.cliamsGrid.pagerModule.pagerObj.pageSize;

    if (G.name == "actionBegin" && G.requestType == "filterbeforeopen") {
      this.claimGridlistBo.type = G.columnType;
    }
  }
  closeViewBatch() {
    this.isViewbatches = false;
  }

 
  GetCliamtypeLov() {
    let params = new URLSearchParams();
    params.append("listCode", "ClaimType");
    this.claimsService
      .getLovType(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.claimstype = data;
        },
        (err: any) => {
          if (err) {
            this.toastservice.error(err, "Error"), 8000;
          }
        }
      );
  }

  GetPaymentStatusListLov() {
    let params = new URLSearchParams();
    params.append("listCode", "Paymentstatus");
    this.claimsService
      .getLovType(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.paymentstatus = data;


        },
        (err: any) => {
          if (err) {
            this.toastservice.error(err, "Error"), 8000;
          }
        }
      );
  }

  payDateChanges(event, type, name) {
    if (type == "inputchanged") {

      if (name == 'startDate') {
        let element = this.dateservice.inputFeildchange(event);
        if (element != undefined) {
          let values = this.dateservice.inputFeildchange(event);
          this.filterStartDate = values;
        }
      }
      if (name == 'endDate') {
        let element = this.dateservice.inputFeildchange(event);
        if (element != undefined) {
          let values = this.dateservice.inputFeildchange(event);
          this.filterEndDate = values;
        }
      }

    }
    if (type == "datechanged") {
      if (name == 'startDate') {
        let element = this.dateservice.Datechange(event);
        if (element != undefined) {
          let values = this.dateservice.Datechange(event);
          this.filterStartDate = values;
        }
      }
      if (name == 'endDate') {
        let element = this.dateservice.Datechange(event);
        if (element != undefined) {
          let values = this.dateservice.Datechange(event);
          this.filterEndDate = values;
        }
      }

    }
  }
  //......................................exportClaimsWithPaginationCsv.....................................................
  exportClaimsCurrentCsv() {
    if (this.activeTab == "readyToBill") {
      this.claimGridlistBo.claimStatusLid = this.claimstatus.filter(
        (s) => s.lovName == "ReadyToBill"
      )[0].id;
      this.claimGridlistBo.pageitem = this.cliamsGrid.pageSettings.pageSize;
      this.claimGridlistBo.currentpageno = this.cliamsGrid.pageSettings.currentPage;
    }
    else if (this.activeTab == "active") {
      this.claimGridlistBo.claimStatusLid = this.claimstatus.filter(
        (s) => s.lovName == "Exported"
      )[0].id;
      this.claimGridlistBo.pageitem = this.cliamsGrid.pageSettings.pageSize;
      this.claimGridlistBo.currentpageno = this.cliamsGrid.pageSettings.currentPage;
    }
    else {
      this.claimGridlistBo.claimStatusLid = this.claimstatus.filter(
        (s) => s.lovName == "Imported"
      )[0].id;
      this.claimGridlistBo.pageitem = this.cliamsGrid.pageSettings.pageSize;
      this.claimGridlistBo.currentpageno = this.cliamsGrid.pageSettings.currentPage;
    }
    this.claimListService.exportClaimsCurrentCsv(this.claimGridlistBo).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      let contentType = 'text/csv';
      const blob = this.b64toBlob(data.fileContents, contentType);
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = "Claim Export";
      a.click();
      document.getElementById("exportascsv").click();

    });
  }
  //...........................................exportClaimsCsv................................................................
  exportClaimsCsv() {
    if (this.activeTab == "readyToBill") {
      this.claimGridlistBo.claimStatusLid = this.claimstatus.filter(
        (s) => s.lovName == "ReadyToBill"
      )[0].id;
    }
    else if (this.activeTab == "active") {
      this.claimGridlistBo.claimStatusLid = this.claimstatus.filter(
        (s) => s.lovName == "Exported"
      )[0].id;
    }
    else {
      this.claimGridlistBo.claimStatusLid = this.claimstatus.filter(
        (s) => s.lovName == "Imported"
      )[0].id;
    }
    this.claimListService.exportClaimsCsv(this.claimGridlistBo).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      let contentType = 'text/csv';
      const blob = this.b64toBlob(data.fileContents, contentType);
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = "Claim Export";
      a.click();
      document.getElementById("exportascsv").click();

    });

  }
  
  b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  //............................................................Move to archive.......................................................
  MovetoArchive() {
    this.IsButtonDisable = true;
    this.claimListService.MovetoarchiveFunction(this.SelectedClaimCheckBox).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.IsButtonDisable = false;
      this.getClaimGridList();
      this.toastservice.success('Claim archived successfully!');
      this.SelectedClaimCheckBox = []
      setTimeout(() => {
        this.toastservice.clear();
      }, 8000);
    },
      (err: any) => {
        this.IsButtonDisable = false;
        this.toastservice.error(err.error, 'error');
        setTimeout(() => {
          this.toastservice.clear();
        }, 8000);
      })
  }
  //............................................................RestoreActive...................................
  RestoreActive() {
    this.IsButtonDisable = true;
    this.claimListService.RestoretoActive(this.SelectedClaimCheckBox).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.IsButtonDisable = false;
      this.toastservice.success('Claim restored to active successfully!');
      this.SelectedClaimCheckBox = []
      this.getClaimGridList();
      setTimeout(() => {
        this.toastservice.clear();
      }, 8000);
    },
      (err: any) => {
        this.IsButtonDisable = false;
        this.toastservice.error(err.error, 'error');
        setTimeout(() => {
          this.toastservice.clear();
        }, 8000);
      })
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    this.global.isCheckOperationDashboardRecord = false
    this.global.globalclaimfilter = null
    this.global.globalClaimType = false
    this.global.globalCLaimStatus = null
    this.claimGridlistBo.claimCategory = "readyToBill"
    this.activeTab = "readyToBill"
  }

}
